<!-- =========================================================================================
    File Name: Home.vue
    Description: Home Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <b-overlay
    :show="show"
    :variant="variant"
    :opacity="opacity"
    :blur="blur"
    rounded="lg"
    spinner-variant="primary"
  >
    <div
      class="vx-col sm:w-full md:w-full lg:w-full xl:w-full sm:m-0 client-portal"
    >
      <b-card class="home-card p-5">
        <h1 class="fw-bolder" :style="textColor">
          {{
            `${this.$t("ClientDesk")} / ${this.$t("Document")} / ${this.$t(
              "Edit"
            )}`
          }}
        </h1>
        <div v-if="appointments">
          <div v-for="(items, index) in appointments" :key="index">
            <div>
              <vs-divider />

              <div class="image-document mt-5">
                <div v-if="!items.is_chat">
                  <h6 :style="textColor">
                    <b>{{ $t("Department") }}</b
                    >: {{ items.department.department_name }}
                  </h6>
                  <h6 :style="textColor">
                    <b>{{ $t("Requirement") }}</b
                    >: {{ items.question }}
                  </h6>
                  <h6 :style="textColor">
                    <b>{{ $t("Document") }}</b
                    >: {{ $t(items.answer_label) }}
                  </h6>
                </div>
                <div v-if="items.is_chat">
                  <h6 :style="textColor">
                    <b>{{ $t("Chat") }}</b
                    >: {{ items.display_name }}
                  </h6>
                  <h6 :style="textColor">
                    <b>{{ $t("SenderName") }}</b
                    >: {{ items.sender_name }}
                  </h6>
                  <!-- <h6 :style="textColor">
                  <b>{{ $t("Document")}}</b>:  {{  items.answer }}
                  </h6>                   -->
                </div>
                <div
                  class="mt-1"
                  v-if="items.answer && (items.status >= 0 || is_chat != 0)"
                  @click=" items.type == 'image' && items.type == 'pdf' ? 
                    showPreview(
                      previewLinks[items.answer],
                      !items.answer.includes('.pdf') ? 'image' : 'other'
                    ) : ''
                  "
                >
                  <div v-if="items.type !== 'image' && items.type !== 'pdf'" class="w-full text-center mt-10">
                      <strong style="font-size: 20px;">No Preview </strong> <br> 
                      <a :download="items.display_name" :href="getFileURL(items)"> Download </a> 
                  </div>
                  <auth-image
                    v-else-if="items.type == 'image' && items.is_chat"
                    :path="items.path"
                    class="document1"
                  />
                  <img
                    v-else-if="!items.is_chat && !items.answer.includes('.pdf')"
                    class="document1"
                    :src="previewLinks[items.answer]"
                    alt="document"
                  />
                  <iframe
                    v-else
                    class="document2 custom-image-class"
                    :src="previewLinks[items.answer]"
                    style="border: none"
                    :key="previewLinks[items.answer]"
                  />
                </div>

                <div v-if="items.answer && items.status == -1" class="main">
                  <div
                    class="dropzone-container"
                    @dragover="dragover"
                    @dragleave="dragleave"
                    @drop="drop(items.question_id,
                            items.answer,
                            $event)"
                    :style="isDragging && 'border-color: green;'"
                  >
                    <div @click="showPreview(
                          previewLinks[items.answer],
                          !items.answer.includes('.pdf') ? 'image' : 'other'
                        )">
                      <img
                        v-if="!items.is_chat && !items.answer.includes('.pdf')"
                        :src="previewLinks[items.answer]"
                        class="document1"
                      />

                      <iframe
                        v-else
                        class="document2 custom-image-class"
                        :src="previewLinks[items.answer]"
                        style="border: none"
                        :key="previewLinks[items.answer]"
                      />
                      <div>
                        <span v-show="items.status == -1" class="stamp is-nope">{{
                          $t("Rejected")
                        }}</span>
                      </div>
                    </div>
                    <div class="vx-col mt-5" :id="`update-${index}`">
                      <input
                        type="file"
                        v-validate="{
                          size: 2048,
                          mimes: [
                            'image/jpeg',
                            'image/jpg',
                            'image/png',
                            'application/pdf',
                          ],
                        }"
                        style="display: none"
                        :name="'name' + index"
                        :data-vv-as="items.answer_label"
                        @change="
                          checkValidation(
                            items.question_id,
                            items.answer,
                            $event
                          )
                        "
                        :ref="`qa_file_input-${index}`"
                        id="fileInput"
                      />
                      <label for="fileInput" class="file-label">
                        <div>
                          <b :style="textColor">{{ $t("chooseFile") }}</b> {{ $t("dragit") }}
                        </div>
                      </label>
                    </div>
                  </div>
                </div>

                <div class="vx-col button-center" :id="`update-${index}`">
                  <b-button
                    :style="buttonCss"
                    v-if="items.is_chat"
                    variant="outline-primary"
                    class="mr-4 border-15 font-16 fw-bolder mt-5 border-primary btn-padding"
                    @click="deleteChatFile(items.answer_id)"
                    ><strong :style="buttonCss.color">{{
                      $t("Delete")
                    }}</strong></b-button
                  >
                </div>
                <div class="w-full p-2 text-center">
                  <span
                    :style="textColor"
                    class="text-danger fw-bolder text-sm"
                    v-show="errors.has(`name${index}`)"
                    >{{ errors.first(`name${index}`) }}</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="w-full" v-else>
          <div class="w-full text-center p-5">
            <h3 :style="textColor">{{ $t("NoDocuments") }}</h3>
          </div>
        </div>

        <div class="mt-2 pt-2">
          <Back />
        </div>
        <ShowFilePreview :previewModal="previewModal"></ShowFilePreview>
      </b-card>
    </div>
  </b-overlay>
</template>

<style>
.main {
    align-items: center;
    justify-content: center;
    text-align: center;
    background: transparent;
    border: 1px dashed #000;
}

.dropzone-container {
    padding: 3rem;  
}

.hidden-input {
    opacity: 0;
    overflow: hidden;
    position: absolute;
    width: 1px;
    height: 1px;
}

.file-label {
    font-size: 15px;
    cursor: pointer;
}

.preview-container {
    display: flex;
    margin-top: 2rem;
}
</style>

<style lang="scss">
.br-20 {
  border-radius: 20px !important;
}
.br-10 {
  border-radius: 10px;
}
.document1 {
  width: 100%;
  height: auto;
  max-width: 100%;
  max-height: 400px;
  object-fit: contain;
}
.document2 {
  width: 100%;
  max-width: 100%;
  height: 400px;
  // object-fit: contain;
}
.stamp {
  transform: rotate(12deg);
  color: #555;
  font-size: 4rem;
  font-weight: 700;
  border: 0.25rem solid #555;
  display: inline-block;
  padding: 0.25rem 1rem;
  text-transform: uppercase;
  border-radius: 1rem;
  font-family: "Courier";
}
.op-4 {
  opacity: 0.4;
}
.is-nope {
  position: absolute;
  top: 40%;
  left: 38%;
  color: orangered;
  // opacity: 0.7;
  border: 0.5rem solid orangered;
  border-left: none;
  border-right: none;
  transform: rotate(-17deg);
  // -webkit-mask-position: 2rem 3rem;
  font-size: 4rem;
}

@media only screen and (max-width: 420px) {
  .is-nope {
    left: 8%;
    font-size: 3rem;
  }
}

@media only screen and (min-width: 420px) and (max-width: 489px) {
  .is-nope {
    left: 20%;
    font-size: 3rem;
  }
}

@media only screen and (min-width: 490px) and (max-width: 754px) {
  .is-nope {
    left: 25%;
    font-size: 3rem;
  }
}

@media only screen and (min-width: 755px) and (max-width: 1000px) {
  .is-nope {
    position: absolute;
    top: 40%;
    left: 32%;
    color: orangered;
    // opacity: 0.7;
    border: 0.5rem solid orangered;
    border-left: none;
    border-right: none;
    transform: rotate(-17deg);
    // -webkit-mask-position: 2rem 3rem;
    font-size: 3rem;
  }
}

@media (min-width: 4103px) and (max-width: 5464px) {
  .is-nope {
    left: 47%;
  }
}

@media (min-width: 2000px) and (max-width: 2732px) {
  .is-nope {
    left: 43%;
  }
}

@media (min-width: 1700px) and (max-width: 2000px) {
  .is-nope {
    left: 41%;
  }
}

@media (min-width: 2733px) and (max-width: 4102px) {
  .is-nope {
    left: 45.5%;
  }
}

.image-document {
  position: relative;
}
.button-center {
  position: relative;
  left: 47.5%;
}

.home-card {
  box-shadow: 0px 3px 8px rgb(100, 100, 100);
  border-radius: 1.2rem !important;
}

.home-card .card-body {
  background-color: nono !important;
  background: none !important;
}
</style>
<script>
import { getLocalData, clearLocalData } from "@/utils/auth";
import $ from "jquery";
import { getFile } from "@/api/staff";
import ShowFilePreview from "@/components/show-file-preview.vue";
import {
  removeQaDocFile,
  replaceQaDocFile,
  rejectQaDocsFile,
  updateFiles,
  get,
} from "@/api/company-users";
import { uploadAndReplaceDocumentForUser } from "@/api/appointment";

import Back from "@/views/users/component/Back";
import { getErrorMessage, parseStringToURLFriendly } from "@/utils/helper";

import moment from "moment";
import AuthImage from "@/components/auth/image";

export default {
  data() {
    return {
      buttonCss: {},
      textColor: {},
      previewModal: {
        show: false,
        link: "",
        type: "image",
      },
      rejected: true,
      doc: [],
      keys: [],
      previewLinks: [],
      documents: [],
      appointments: [],
      filename: "",
      label: "",
      id: "",
      error: "",
      success: "",
      sec: 2,
      show: false,
      variant: "light",
      opacity: 0.85,
      blur: "2px",
      is_chat: 0,
      isDragging: false,
    };
  },
  created() {
    this.id = this.$route.params.id;
    this.is_chat = this.$route.params.chat;
    // this.filename = this.$route.query.filename;
    // this.label = this.$route.query.label;
    this.getDocuments(this.id, this.is_chat);
    let details = getLocalData();
    if (details.company_id) this.getCustomStyle(details.company_id);
  },
  components: {
    Back,
    ShowFilePreview,
    AuthImage,
  },
  computed: {
    day() {
      return moment().format("dddd");
    },
    month() {
      return moment().format("MMMM");
    },
    day1() {
      return moment().format("D");
    },
    // getdate() {
    //   return moment().format("YYYY-MM-DD");
    // },
    current_date() {
      return moment().format("DD/MM/YYYY");
    },
  },
  methods: {
    dragover(e) {
      e.preventDefault();
      this.isDragging = true;
    },
    dragleave() {
      this.isDragging = false;
    },
    drop(id, key, e) {
      e.preventDefault();
      this.replaceAnswerDoc(id, key, e.dataTransfer.files[0]);
      this.isDragging = false;
    },
    getCustomStyle(id) {
      let data = {
        company_id: id,
      };
      this.$store
        .dispatch("GetCustomStyle", data)
        .then((res) => {
          if (res.data.data.header_text)
            $(".header-text").html(res.data.data.header_text);
          if (res.data.data.footer_text)
            $(".footer-text").html(res.data.data.footer_text);

          $(".home-card").css({
            "background-color": res.data.data.form_background_color,
          });
          $(
            "span.vfc-span-day.vfc-disabled.vfc-cursor-not-allowed.vfc-hover, .vfc-day, .vfc-top-date.vfc-center span, span.e-input-group-icon.e-ddl-icon.e-search-icon"
          ).css({ color: res.data.data.form_text_color });
          $(".vfc-arrow-right, .vfc-arrow-left").css({
            "border-color": res.data.data.form_text_color,
          });

          $(".custome-text-color").css({
            color: res.data.data.form_text_color,
          });
          let css = {
            color: this.textColor.color,
            "border-bottom-color": this.textColor.color,
          };
          $(".e-control-wrapper").css(css);
          $("span.e-input-group-icon.e-ddl-icon.e-search-icon").css(
            this.textColor
          );
          this.textColor = {
            color: res.data.data.form_text_color + " !important",
          };

          $(".the-footer p, .the-footer a").css({
            color: res.data.data.form_text_color,
          });

          this.buttonCss = {
            "background-color":
              res.data.data.button_background_color + "!important",
            "border-color":
              res.data.data.button_background_color + "!important",
            color: res.data.data.button_text_color + "!important",
          };
          if (res.data.data.background_images)
            $("#content-area").css({
              "background-image":
                "url('" + res.data.data.background_images.path + "')",
              "background-position": "inherit",
              "background-repeat": "no-repeat",
              "background-size": "cover",
              "background-attachment": "fixed",
            });
          else $("#content-area").css({ "background-image": "none" });
        })
        .catch((error) => {
          this.$log.error(
            "File : BookingForm.vue | Function : getCustomStyle() | Error :",
            error
          );
          // Error response
          this.error =
            this.$t(error.replace(/[\s\/]/g, "")) !==
            error.replace(/[\s\/]/g, "")
              ? this.$t(error.replace(/[\s\/]/g, ""))
              : error;
          this.$toasted.show(this.error, {
            className: "top-alert",
            position: "top-center",
            type: "error",
            duration: 2000,
          });
          return false;
        });
    },
    checkValidation(id, key, event) {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.replaceAnswerDoc(id, key, event.target.files[0]);
        }
      });
    },
    uploadHandler(index1, index) {
      console.log(this.$refs[`qa_file_input-${index1}`]);
    },
    showPreview(link, type = "image") {
      this.previewModal.show = true;
      this.previewModal.link = link;
      this.previewModal.type = type;
    },
    removed() {
      this.show = false;
    },
    async replaceAnswerDoc(id, key, file) {
      console.log('file', file);
      const isOk = await this.$swal({
        title: this.$t("ReplaceQaDocument"),
        type: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t("Yes"),
        confirmButtonColor: "#7367F0",
        cancelButtonText: this.$t("No"),
        showCloseButton: true,
        showLoaderOnConfirm: true,
        onClose: this.removed(),
      });
      if (!isOk.value) return false;

      try {
        this.show = false;
        const fd = new FormData();
        fd.append("appointment_question_answer_id", this.id);
        fd.append("file", file);
        const res = await uploadAndReplaceDocumentForUser(id, fd);
        this.getDocuments(this.id, this.is_chat);
        //location.reload();
        //this.$router.go(-1);
        //this.$router.push({ path: "/user/documents" });
        this.$toasted.show(this.$t("UpdateUserFile"), {
          className: "top-alert",
          position: "top-center",
          type: "success",
          duration: 2000,
        });
      } catch (error) {
        this.catchMethod(error);
      }
    },
    async showFile(filename, type, folder) {
      if (this.previewLinks[filename]) return;
      const response = await getFile(`${folder}`);
      let url = URL.createObjectURL(response.data);
      this.$set(this.previewLinks, filename, url);
      //      this.urltoFile(
      //   url,
      //   filename,
      //   "image/*"
      // ).then(function (file) {

      //   this.previewLinks=file;
      //   // obj.previewLinks = file;
      // });
    },

    async getFile() {
      // this.show = true;
      const ext = filename.split(".").pop();
      const response = await getFile(`appointment-documents/${this.filename}`);
      const url = URL.createObjectURL(response.data);
      console.log(url);
      this.show = false;
    },
    catchMethod(error) {
      this.$log.error(
        "File : List.vue | Function : getAppointments() | Error :",
        error
      );
      this.show = false;
      // Error response
      this.error =
        this.$t(error.replace(/[\s\/]/g, "")) !== error.replace(/[\s\/]/g, "")
          ? this.$t(error.replace(/[\s\/]/g, ""))
          : error;
      this.$toasted.show(this.error, {
        className: "top-alert",
        position: "top-center",
        type: "error",
        duration: 2000,
      });
      return false;
    },
    getDocuments(id, chat) {
      this.show = true;
      var data = {
        params: {
          question_type: "file",
          answer_id: id,
          is_chat: chat == 1 ? true : false,
        },
      };
      let api = "GetUserDocuments";
      this.$store
        .dispatch(api, data)
        .then((res) => {
          this.show = false;
          this.appointments = res.data.data;
          let folder = "";
          res.data.data.forEach((el) => {
            folder = el.is_chat
              ? el.path
              : `appointment-documents/${el.answer}`;
            this.showFile(el.answer, "image", folder);
          });
        })
        .catch((error) => {
          this.catchMethod(error);
        });
    },
    deleteChatFile(id) {
      this.$store
        .dispatch("DeleteChatFile", id)
        .then((res) => {
          this.$toasted.show(this.$t("FileDeleted"), {
            className: "top-alert",
            position: "top-center",
            type: "success",
            duration: 2000,
          });

          this.$router.push({ path: "/user/documents" });
        })
        .catch((error) => {
          this.catchMethod(error);
        });
    },
    async getFileURL(file) {
      const response = await getFile(file.path);
      return URL.createObjectURL(response.data);
    },
  },
};
</script>